module.exports = __webpack_public_path__ + "img/logo.ba81bf8b.png";